import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchBrevoTemplates() {
    try {
        const result = yield call(AxiosCall, '/brevo/get_all_templates/');
        yield put(actions.fetchBrevoTemplatesSuccess(result.data.results));
    } catch (e) {
        yield put(actions.fetchBrevoTemplatesFailure(e));
    }
}

export default function* rootSaga() {
    yield all([
        // watchers contacts
        takeLatest(actions.FETCH_BREVO_TEMPLATES.REQUEST, fetchBrevoTemplates),
    ])
}